import * as ort from "onnxruntime-web";

const CLASSES = [
  "Fake Black Label",
  "Fake Classic Label",
  "No Label Found (Try cropping your image)",
  "Real Black Label",
  "Real Classic Label",
];
const IMG_SIZE = 224;

// ConvNeXt-V2 atto, INT8, temperature-calibrated (Model and Datasets runs/v1.2)
const MODEL_URL = "./onnx_v1.2/convnextv2_atto_int8.onnx";

// ImageNet normalization constants (must match training preprocessing)
const MEAN = [0.485, 0.456, 0.406];
const STD = [0.229, 0.224, 0.225];

export async function loadModel(setModel) {
  try {
    console.log("Loading ONNX model...");

    const modelBuffer = await fetch(MODEL_URL).then((r) => r.arrayBuffer());
    const session = await ort.InferenceSession.create(modelBuffer);

    console.log("ONNX model loaded successfully", session);
    setModel(session);
  } catch (error) {
    console.error("Failed to load ONNX model:", error);
  }
}

/**
 * Preprocess an image element into an ONNX-ready Float32Array in NCHW format.
 * Pipeline: resize → [0,1] → ImageNet normalize → NCHW layout
 */
function preprocessImage(image) {
  const canvas = document.createElement("canvas");
  canvas.width = IMG_SIZE;
  canvas.height = IMG_SIZE;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, IMG_SIZE, IMG_SIZE);
  const imageData = ctx.getImageData(0, 0, IMG_SIZE, IMG_SIZE);
  const { data } = imageData; // RGBA flat array

  // Create NCHW tensor: [1, 3, 224, 224]
  const float32Data = new Float32Array(1 * 3 * IMG_SIZE * IMG_SIZE);
  for (let y = 0; y < IMG_SIZE; y++) {
    for (let x = 0; x < IMG_SIZE; x++) {
      const pixelIdx = (y * IMG_SIZE + x) * 4; // RGBA index
      for (let c = 0; c < 3; c++) {
        const val = data[pixelIdx + c] / 255.0; // scale to [0, 1]
        const normalized = (val - MEAN[c]) / STD[c]; // ImageNet normalize
        float32Data[c * IMG_SIZE * IMG_SIZE + y * IMG_SIZE + x] = normalized;
      }
    }
  }

  return new ort.Tensor("float32", float32Data, [1, 3, IMG_SIZE, IMG_SIZE]);
}

export const modelPredict = async (image, session, dispatch) => {
  const inputTensor = preprocessImage(image);

  console.log("Running ONNX inference...");
  console.log(session);

  const feeds = { input: inputTensor };
  const results = await session.run(feeds);
  const output = results.output;

  const prediction = Array.from(output.data);
  console.log(prediction);

  // Apply softmax if the model outputs raw logits
  const softmaxPrediction = softmax(prediction);
  console.log("softmax:", softmaxPrediction);

  const certainty = Math.max(...softmaxPrediction);
  const result = CLASSES[softmaxPrediction.indexOf(certainty)];
  const response = { result: result, certainty: certainty };
  console.log(result);
  return response;
};

function softmax(arr) {
  const maxVal = Math.max(...arr);
  const exps = arr.map((x) => Math.exp(x - maxVal));
  const sumExps = exps.reduce((a, b) => a + b, 0);
  return exps.map((e) => e / sumExps);
}

export const getTensor = async (image) => {
  return preprocessImage(image);
};
